$(document).ready(function (){
    $('.featured--slider1').slick({
      infinite: true,
      slidesToShow: 4, 
      autoplay: true,
      dots: false,
      slidesToScroll: 1, 
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerPadding: '40px',
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerPadding: '40px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  //homepage slider collection
      $('ul.collection_slider').slick({
      infinite: true,
      slidesToShow: 4, 
      autoplay: false,
      dots: false,
      slidesToScroll: 1, 
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerPadding: '40px',
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerPadding: '40px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
/* You May Also Like */
    setTimeout(function() {
    $('.recommendation_slider').slick(
      {
        infinite: true,
        slidesToShow: 4, 
        autoplay: true,
        dots: false,
        slidesToScroll: 1, 
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              centerPadding: '40px',
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: true,
              centerPadding: '40px',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      })

  }, 2500);

/* You May Also Like */ 
});

 /* Collection Page Accordion code by Raj */ 
 
     $('.acnav__label').click(function () {
                  	var label = $(this);
                  	var parent = label.parent('.has-children');
                  	var list = label.siblings('.acnav__list');
                if ( parent.hasClass('is-open') )
                     {
                      label.removeClass("icon-new");
                		list.slideUp('200');
                		parent.removeClass('is-open');
          	      }
          	  else {
                      label.addClass("icon-new");
              		list.slideDown('200');
              		parent.addClass('is-open');
          	      }
                });
/* Collection Page Accordion code by Raj */
/* Product Page */
// $(".custom-dispay-flex label").click(function(event){
//     // alert("Hello");
//    var current_url = $(location).attr('href')
//     setTimeout(function() {
//    var url_1  = window.location.href;
//   if(current_url != url_1 ){
//     window.location.href = url_1;
//     }
//     }, 400);
//     }); 
// /* Product Page */ 



 